<div style="width: 500px; height: 300px;" data-cy="fee-doctor-form-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-doctor-form-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-doctor-form-header">
      <div class="section-header-title" data-cy="fee-doctor-form-title">
        <span *ngIf="!copyMode" data-cy="fee-doctor-form-add-title">Add {{ this.titleName }} Fees For Doctor</span>
        <span *ngIf="copyMode" data-cy="fee-doctor-form-copy-title">Choose doctor to copy fees to</span>
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="fee-doctor-form-content">
      <div *ngIf="isLoading" style="width: 100%; height: 100%;" data-cy="fee-doctor-form-loading">
        <div *ngIf="Description" data-cy="fee-doctor-form-saving-text">Saving</div>
        <app-tdo-progress-spinner data-cy="fee-doctor-form-spinner"></app-tdo-progress-spinner>
      </div>
      <div *ngIf="!isLoading" data-cy="fee-doctor-form-fields">
        <mat-form-field class="doctor-input-field full-width" data-cy="fee-doctor-form-doctor-field">
          <mat-label data-cy="fee-doctor-form-doctor-label">Select a Doctor</mat-label><br/>
          <mat-select matNativeControl
                      required
                      [(ngModel)]="DoctorId"
                      (selectionChange)="changeDescription($event)"
                      data-cy="fee-doctor-form-doctor-select">
            <mat-option *ngFor="let doctor of doctorList" [value]="doctor.DoctorId" data-cy="fee-doctor-form-doctor-option">
              {{ doctor.Title }} {{ doctor.FirstName }}
              {{ doctor.LastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--  </div>-->
        <!--  <div *ngIf="!this.isNew">-->
        <!--    <mat-form-field class="doctor-input-field full-width">-->
        <!--      <mat-label>Select a Doctor</mat-label>-->
        <!--      <mat-select matNativeControl-->
        <!--                  required-->
        <!--                  [(ngModel)]="DoctorId"-->
        <!--                  (selectionChange)="changeDescription($event)">-->
        <!--        <mat-option *ngFor="let doctor of this.feeSchedule.dataFeeScheduleDoctors" [value]="doctor.DocFeeScheduleID">-->
        <!--          {{ doctor.Description }}-->
        <!--        </mat-option>-->
        <!--      </mat-select>-->
        <!--    </mat-form-field>-->
        <!--  </div>-->

        <mat-form-field class="full-width" data-cy="fee-doctor-form-description-field">
          <mat-label data-cy="fee-doctor-form-description-label">Fee Schedule Description</mat-label><br/>
          <input matInput
                 [(ngModel)]="Description"
                 (change)="userHasChangedDescription = true"
                 data-cy="fee-doctor-form-description-input" />
        </mat-form-field>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="fee-doctor-form-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-doctor-form-cancel-button">Cancel</button>
      <button (click)="onOkClick()" [disabled]="!Description" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-doctor-form-ok-button">Ok</button>
    </div>
  </div>
</div>

<!--<div *ngIf="!isLoading" class="main-container">
  <div style="padding-bottom:15px" *ngIf="!copyMode">
    <h5>Add {{ this.titleName }} Fees For Doctor</h5>
  </div>
  <div style="padding-bottom:15px" *ngIf="copyMode">
    <h5>Choose doctor to copy fees to:</h5>
  </div>

&lt;!&ndash;  <mat-radio-group aria-label="Select an option" (change)="showNewOrCopy($event.value)">&ndash;&gt;
&lt;!&ndash;    <mat-radio-button value="1" [checked]="true">Blank</mat-radio-button>&ndash;&gt;
&lt;!&ndash;    <mat-radio-button value="2" style="margin-left:10px;">Copy From Another Doctor</mat-radio-button>&ndash;&gt;
&lt;!&ndash;  </mat-radio-group>&ndash;&gt;

&lt;!&ndash;  <div *ngIf="this.isNew">&ndash;&gt;
    <mat-form-field class="doctor-input-field full-width">
      <mat-label>Select a Doctor</mat-label>
      <mat-select matNativeControl
                  required
                  [(ngModel)]="DoctorId"
                  (selectionChange)="changeDescription($event)">
        <mat-option *ngFor="let doctor of doctorList" [value]="doctor.DoctorId">
          {{ doctor.Title }} {{ doctor.FirstName }}
          {{ doctor.LastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
&lt;!&ndash;  </div>&ndash;&gt;
&lt;!&ndash;  <div *ngIf="!this.isNew">&ndash;&gt;
&lt;!&ndash;    <mat-form-field class="doctor-input-field full-width">&ndash;&gt;
&lt;!&ndash;      <mat-label>Select a Doctor</mat-label>&ndash;&gt;
&lt;!&ndash;      <mat-select matNativeControl&ndash;&gt;
&lt;!&ndash;                  required&ndash;&gt;
&lt;!&ndash;                  [(ngModel)]="DoctorId"&ndash;&gt;
&lt;!&ndash;                  (selectionChange)="changeDescription($event)">&ndash;&gt;
&lt;!&ndash;        <mat-option *ngFor="let doctor of this.feeSchedule.dataFeeScheduleDoctors" [value]="doctor.DocFeeScheduleID">&ndash;&gt;
&lt;!&ndash;          {{ doctor.Description }}&ndash;&gt;
&lt;!&ndash;        </mat-option>&ndash;&gt;
&lt;!&ndash;      </mat-select>&ndash;&gt;
&lt;!&ndash;    </mat-form-field>&ndash;&gt;
&lt;!&ndash;  </div>&ndash;&gt;

  <mat-form-field class="full-width">
    <input matInput
           [(ngModel)]="Description"
           placeholder="Fee Schedule Description"
           (change)="userHasChangedDescription = true" />
  </mat-form-field>

  <div class="action-container">
    <button mat-raised-button #btnCreate disabled="disabled" color="primary" class="action-button" (click)="close()">Create</button>
    <button mat-button color="warn" class="action-button" (click)="cancel()">Cancel</button>
  </div>
</div>
<div *ngIf="isLoading" class="spinner-holder">
  <mat-spinner></mat-spinner>
</div>-->
